"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddToCartButton = exports.LoaderIcon = exports.ButtonBlock = exports.PartInputsContainer = exports.CloseButton = exports.SubText = exports.ZapIcon = exports.ButtonWithIcon = exports.ButtonWithDropdownContainer = exports.InputContainer = exports.InputRow = exports.NewRowText = exports.NewRowButton = exports.Title = exports.TopRow = exports.OrderContainer = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../../UI/Typography"));
const Button_1 = __importDefault(require("../../Button"));
const svg_components_1 = require("../../../assets/svg-components");
exports.Container = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${props => props.theme.spacing.m1}px;

  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    flex-direction: column;
    align-items: flex-end;
    height: auto;
  }
`;
exports.OrderContainer = styled_components_1.default.div `
  padding: ${props => props.theme.spacing.s4}px;
  position: absolute;
  border: 1px solid ${props => props.theme.palette.DARK_GRAY_20};
  box-shadow: ${props => props.theme.attributes.boxShadow.top2};
  width: ${props => props.theme.constants.quickOrder.dropdownWidth}px;
  top: ${props => props.theme.constants.blockHeight.s2}px;
  background: ${props => props.theme.palette.BW_100};
  z-index: ${props => props.theme.attributes.zIndex.sm};

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    ${props => props.open && props.width && `width: ${props.width - props.theme.constants.blockWidth.s11}px;`}
  }
`;
exports.TopRow = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
exports.Title = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0 0 ${props => props.theme.spacing.s2}px 0;
`;
exports.NewRowButton = (0, styled_components_1.default)(Button_1.default) `
  padding: 0;
`;
exports.NewRowText = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.BLUE_100};
  text-decoration: underline;
`;
exports.InputRow = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${props => props.theme.spacing.s4}px;
`;
exports.InputContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  column-gap: ${props => props.theme.spacing.s2}px;
`;
exports.ButtonWithDropdownContainer = styled_components_1.default.div `
  position: relative;
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: ${props => props.theme.spacing.s5}px;
  }
`;
exports.ButtonWithIcon = (0, styled_components_1.default)(Button_1.default) `
  padding: ${props => props.theme.spacing.s6}px ${props => props.theme.spacing.s3}px;
  font-weight: ${props => props.theme.typography.weight.regular};
  font-size: ${props => props.theme.typography.size.s2}px;
  width: max-content;
`;
exports.ZapIcon = (0, styled_components_1.default)(svg_components_1.ZapIcon) `
  margin-right: ${props => props.theme.spacing.s2}px;
`;
exports.SubText = (0, styled_components_1.default)(Typography_1.default) `
  margin-bottom: ${props => props.theme.spacing.m2}px;
`;
exports.CloseButton = styled_components_1.default.button `
  border: none;
  background: none;
  ${props => (props === null || props === void 0 ? void 0 : props.deleteRow) &&
    ` svg {
    width: ${props.theme.spacing.s3}px;
    margin-left: ${props.theme.spacing.s3}px;
    }
  `}

  ${props => !props.disabled &&
    `cursor: pointer;
  &:hover {
    svg > path {
      stroke: ${props.theme.palette.LIGHT_BLACK};
    }
  }`}
`;
exports.PartInputsContainer = styled_components_1.default.div `
  max-height: ${props => props.theme.constants.blockHeight.m11}px;
  overflow: auto;
  padding: ${props => props.theme.spacing.xs1}px ${props => props.theme.spacing.s3}px 0
    ${props => props.theme.spacing.xs1}px;
  margin-bottom: ${props => props.theme.spacing.s4}px;
`;
exports.ButtonBlock = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
exports.LoaderIcon = (0, styled_components_1.default)(svg_components_1.GradientLoaderIcon) `
  -webkit-animation: ${props => props.theme.themeKeyframes.rotation} 1s infinite linear;
  width: ${props => props.theme.constants.blockHeight.s12}px;
  height: ${props => props.theme.constants.blockHeight.s12}px;
`;
exports.AddToCartButton = (0, styled_components_1.default)(Button_1.default) `
  height: ${props => props.theme.constants.SelectDropdownHeight.md}px;
  padding: ${props => props.theme.spacing.s6}px ${props => props.theme.spacing.s3}px;
`;
exports.default = {
    SubText: exports.SubText,
    Container: exports.Container,
    OrderContainer: exports.OrderContainer,
    TopRow: exports.TopRow,
    Title: exports.Title,
    NewRowButton: exports.NewRowButton,
    NewRowText: exports.NewRowText,
    InputRow: exports.InputRow,
    InputContainer: exports.InputContainer,
    ButtonWithDropdownContainer: exports.ButtonWithDropdownContainer,
    ButtonWithIcon: exports.ButtonWithIcon,
    ZapIcon: exports.ZapIcon,
    CloseButton: exports.CloseButton,
    PartInputsContainer: exports.PartInputsContainer,
    ButtonBlock: exports.ButtonBlock,
    LoaderIcon: exports.LoaderIcon,
    AddToCartButton: exports.AddToCartButton
};
